import script from "./ForumPostDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ForumPostDetail.vue?vue&type=script&setup=true&lang=js"

import "./ForumPostDetail.vue?vue&type=style&index=0&id=7b5e7090&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b5e7090"]])

export default __exports__